<template>
    <div class="opponent-search-bar form">
        <input
            class="form-control"
            :value="username"
            placeholder="Opponent"
            name="username"
            autocomplete="off"
            @input="updateUsername($event.target.value); onSearch($event.target.value)"
            ref="username"
        />
        <div class="results" v-if="showResults && username">
            <div class="result"
                v-for="(opponent, i) in opponents" :key="`opponent-result-${i}`"
                @click="onSelectOpponent(opponent)"
            >
                <span>
                    {{opponent.username}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';

export default {
    name: 'OpponentSearchBar',
    props: ['callback', 'selectedOpponent', 'userUuid'],
    mounted() {
        if (this.username) {
            this.$refs.username.focus();
        }
    },
    data() {
        return {
            showResults: false,
        };
    },
    computed: {
        username() {
            return this.$store.state.opponentSearchBarState.username;
        },
        loaded() {
            return this.$store.state.opponentSearchBarState.loaded;
        },
        opponents() {
            return this.$store.state.opponentSearchBarState.opponents;
        },
    },
    methods: {
        async updateUsername(username) {
            await this.$store.dispatch('setOpponentUsername', username);

            if (this.selectedOpponent &&
                this.selectedOpponent.username !== username &&
                typeof this.callback === 'function'
            ) {
                this.callback(null);
            }
        },
        onSearch: debounce(async function onSearch(opponentUsername) {
            if (opponentUsername === '') {
                await this.$store.dispatch('setOpponentsLoaded', false);
                await this.$store.dispatch('setOpponents', []);
                return;
            }

            const options = {
                page: 1,
                userUuid: this.userUuid,
                opponentUsername,
            };

            await this.$store.dispatch('getOpponents', options);

            if (this.opponents.length && this.loaded) {
                this.showResults = true;
            }
        }, 550),
        onSelectOpponent(opponent) {
            this.updateUsername(opponent.username);
            this.showResults = false;

            if (typeof this.callback === 'function') {
                this.callback(opponent);
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .opponent-search-bar {
        position: relative;


        .form-control {
            border: 1px solid  $sage-brown;
            box-shadow: 0 2px $sage-brown;
        }

        .results {
            background: white;
            border-radius: 4px;
            border: 1px solid $light-gray;
            box-sizing: border-box;
            max-height: 200px;
            min-height: 43px;
            overflow-y: auto;
            position: absolute;
            top: calc(100% + 4px);
            width: 100%;
            z-index: 1;

            .result {
                cursor: pointer;
                padding: 10px 20px;
				text-align: left;

                &:hover {
                    background: $light-gray;
                }
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {
    }

    @media only screen and (min-width: $screen-md) {
    }

</style>
